<header class="header-wrapper">
	<!-- Header top line -->
	<div class="top-header" id="top-header">
		<div class="container">
			<div class="top-line">
				<a id="mainUkrposhtaLogoLink" href="https://{{wwwContent}}ukrposhta.ua/ua/">
					<!-- <app-site-logo-winter> </app-site-logo-winter> -->
					<app-site-logo> </app-site-logo>
				</a>
				<div class="header-call-center">
					<p><a class="text-decoration" href="mailto:ukrposhta@ukrposhta.ua"><b>ukrposhta@ukrposhta.ua</b></a></p>
					<!-- <p><a class="text-decoration" id="contact-center-link" href="http://m.me/272960602750601" target="_blank">контакт-центр</a></p> -->
					<p class="text-decoration">контакт-центр</p>
				</div>
			</div>
		</div>
	</div>
	<!-- Header bottom line -->
	<div class="bottom-header" id="bottom-header">
		<div class="container">
			<div class="bottom-line" id="bottom-line">
				<div class="burger" (click)="showMobileMenu()">
					<div class="burger-box">
						<div class="burger-inner"></div>
					</div>
				</div>
				<nav class="main-navbar">
					<ul class="main-navbar-list">
						<li class="main-navbar-list-item">
							<a class="main-navbar-link" href="https://postmark.ukrposhta.ua" (click)="hideDropDownMenu()">Маркет</a>
						</li>
						<li class="main-navbar-list-item">
							<a class="main-navbar-link" href="https://apteka.ukrposhta.ua/" (click)="hideDropDownMenu()">Аптека</a>
						</li>
						<li class="main-navbar-list-item">
							<a class="main-navbar-link" href="https://track.ukrposhta.ua/tracking_UA.html" (click)="hideDropDownMenu()">Трекінг</a>
						</li>
						<li class="main-navbar-list-item">
							<a class="main-navbar-link active" href="javascript:void(0);" id="services-link" (click)="toggleServicesDropdown(); $event.stopPropagation()">Послуги</a>
						</li>
						<li class="main-navbar-list-item">
							<a class="main-navbar-link" href="javascript:void(0);" id="tariffs-link" (click)="togglePricesDropdown(); $event.stopPropagation()">Тарифи</a>
						</li>
						<li class="main-navbar-list-item">
							<a class="main-navbar-link no-dd" href="https://offices.ukrposhta.ua" (click)="hideDropDownMenu()">Відділення</a>
						</li>
						<li class="main-navbar-list-item">
							<a class="main-navbar-link" href="javascript:void(0);" id="philately-link" (click)="togglePhilatelyDropdown(); $event.stopPropagation()">Філателія</a>
						</li>
						<li class="main-navbar-list-item">
							<a class="main-navbar-link no-dd" href="https://{{wwwContent}}ukrposhta.ua/ua/vacancies/" (click)="hideDropDownMenu()">Кар’єра</a>
						</li>
						<li class="main-navbar-list-item">
                            <a class="main-navbar-link" href="javascript:void(0);" id="dlia-biznesu-link" (click)="toggleDliaBiznesuDropdown(); $event.stopPropagation()">Для бізнесу</a>
                        </li>
					</ul>
				</nav>
				<div class="user-account col-auto">
					<a class="user-account col-auto" href="https://ok.ukrposhta.ua/ua/">
						<span class="login-text">Вхід / </span>
					</a>
					<a class="user-account col-auto" href="https://ok.ukrposhta.ua/ua/register">
						<span class="login-text">Реєстрація </span>
						<app-profile-icon></app-profile-icon>
					</a>
				</div>
			</div>
		</div>
		<div class="services-sub-menu" id="services-sub-menu" [@slideInOut]="servicesMenuOpen">
			<div class="container">
				<div class="sub-menu-wrapper">
					<div class="sub-menu-col">
						<ul class="sub-menu-list">
							<li class="sub-menu-title">Поштові послуги</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/ekspres">Доставка за тарифом «Пріоритетний»</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/standart">Доставка за тарифом «Базовий»</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/dokumenty">Укрпошта Документи</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/mizhnarodnyi-poshtovyi-perekaz">Міжнародні поштові перекази</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/dostavka-po-svitu">Доставка по світу</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/dostavka-v-ukrainu">Доставка в Україну</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/vidpravlennia-v">Вантаж</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/lysty-ta-poshtovi-kartky">Листи та листівки</a>
							</li>
							<!-- <li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/banderol">Бандероль</a>
							</li> -->
							<li>
								<a href="http://services.ukrposhta.com/courier" target="_blank">Кур’єрська доставка</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/upakuvannia">Паковання</a>
							</li>
                            <li>
                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/dostavka-z-internet-mahazyniv-ukrposhtoiu">Доставка з інтернет-магазинів</a>
                            </li>
                            <li>
                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/sezon-ogorodiv">Доставка товарів для саду</a>
                            </li>
						</ul>
					</div>
					<div class="sub-menu-col">
						<ul class="sub-menu-list">
							<li class="sub-menu-title">Сервіси</li>
							<li>
								<a href="https://calc.ukrposhta.ua">Калькулятор</a>
							</li>
							<li>
								<a href="https://ok.ukrposhta.ua/ua">Оформити відправлення</a>
							</li>
							<li>
								<a href="https://index.ukrposhta.ua/find-post-index/" routerLink="find-post-index" routerLinkActive="active">Знайти індекс</a>
							</li>
							<li>
								<a href="https://index.ukrposhta.ua/find-address/" routerLink="find-address" routerLinkActive="active" >Знайти адресу</a>
							</li>
							<li>
								<a href="https://offices.ukrposhta.ua/">Знайти відділення</a>
							</li>
							<li>
								<a href="https://track.ukrposhta.ua/tracking_UA.html">Трекінг</a>
							</li>
                            <li>
                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/pereadresuvannya-vidpravlennya/">Переадресація відправлення</a>
                            </li>
                            <li>
                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/rozshuk-vrpv">Компенсація (рекламація)</a>
                            </li>
						</ul>
					</div>
					<div class="sub-menu-col">
						<ul class="sub-menu-list">
							<li class="sub-menu-title">Фінансові послуги</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/perekazy-v-mezhakh-ukrainy">Внутрішні грошові перекази</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/mizhnarodni-platizhni-systemy">Міжнародні платіжні системи (перекази MoneyGram)</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/vnutrishnoderzhavni-platizhni-systemy">Внутрішньодержавні платіжні системи</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/platezhi">Платежі</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/Vydacha-hotivkovykh-hryven-ta-popovnennia-platizhnykh-kartok-cherez-POS-terminaly">Видача готівкових гривень та/або поповнення платіжних карток через POS-термінали</a>
							</li>
                            <li>
                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/valiutno-obminni-operatsii">Валютно-обмінні операції</a>
                            </li>
						</ul>
					</div>
					<div class="sub-menu-col">
						<ul class="sub-menu-list">
							<li class="sub-menu-title">Інші послуги</li>
                            <li>
                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/pensii">Пенсії</a>
                            </li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/onlain-servisy">Онлайн-сервіси</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/periodychni-vydannia">Періодичні медіа</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/dlia-vydavtsiv">Для видавців</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/forma-zvorotnoho-zviazku">Зворотний зв’язок за передплатою</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/sekohrama">Секограма</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/vlasna-marka">Продукти «Власної марки»</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/strakhuvannia">Страхові послуги</a>
							</li>
                            <li>
                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/kataloh-ukrposhta-market">Каталог «Укрпошта Маркет»</a>
                            </li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="tariffs-sub-menu" id="tariffs-sub-menu" [@slideInOut]="pricesMenuOpen">
			<div class="container">
				<div class="sub-menu-wrapper">
					<div class="sub-menu-col">
						<ul class="sub-menu-list">
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-ukrposhta-priorytetnyi">Посилки</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy">Доставка за кордон</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-ukrposhta-dokumenty">Листи та документи</a>
							</li>
						</ul>
					</div>
					<div class="sub-menu-col">
						<ul class="sub-menu-list">
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-platezhi">Фінансові послуги</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-na-pryimannia-ta-dostavku-vydan-za-peredplatoiu">Передплата журналів та газет</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-masovyi-kurierskyi-zabir-abo-dostavka">Кур’єрські послуги</a>
							</li>
						</ul>
					</div>
					<div class="sub-menu-col">
						<ul class="sub-menu-list">
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-vidpravlennia-v">Вантаж</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-inshi-posluhy">Інше</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="philately-sub-menu" id="philately-sub-menu" [@slideInOut]="philatelyMenuOpen">
			<div class="container">
				<div class="sub-menu-wrapper">
					<div class="sub-menu-col">
						<ul class="sub-menu-list">
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/informatsiia-dlia-pokuptsiv">Інформація для покупців</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/tematychni-plany-vypusku-produktsii">Тематичнi плани випуску продукції</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/filatelistychnyi-abonement">Філателістичний абонемент</a>
							</li>
                            <li>
                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/marky-voiennoho-chasu">Поштові марки України воєнного часу</a>
                            </li>
                            <li>
                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/poriadok-podachi-propozytsii">Порядок подачі пропозицій</a>
                            </li>
						</ul>
					</div>
					<div class="sub-menu-col">
						<ul class="sub-menu-list">
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/spetsialni-poshtovi-shtempeli-postiinoi-dii">Спеціальні поштові штемпелі постійної дії</a>
							</li>
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/zhurnal-filateliia-ukrainy">Журнал «Філателія України»</a>
							</li>
							<!-- <li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/filatelistichni-vistavky">Філателістичні виставки</a>
							</li> -->
							<li>
								<a href="https://{{wwwContent}}ukrposhta.ua/ua/aleia-poshtovykh-marok">Алея поштових марок</a>
							</li>
                            <li>
                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/marky-na-pidtrymku-ukrainy">Марки світу на підтримку України</a>
                            </li>
						</ul>
					</div>
					<div class="sub-menu-col">
						<app-own-mark></app-own-mark>
					</div>
				</div>
			</div>
		</div>
        <div class="dlia-biznesu-sub-menu" id="dlia-biznesu-sub-menu" [@slideInOut]="dliaBiznesuMenuOpen">
            <div class="container">
                <div class="sub-menu-wrapper">
                    <div class="sub-menu-col">
                        <ul class="sub-menu-list">
                            <li>
                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/ukrposhta-dlia-biznesu">Послуги</a>
                            </li>
                        </ul>
                    </div>
                    <div class="sub-menu-col">
                        <ul class="sub-menu-list">
                            <li>
                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/become-a-partner">Партнерські відділення</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
	</div>
</header>
<div class="mobile-menu" id="mobile-menu">
	<div class="container">
		<div class="mobile-menu-wrapper">
			<div class="mobile-menu-links-wrapper">
				<a class="mobile-menu-links" href="https://{{wwwContent}}ukrposhta.ua/ua">Головна</a>
				<a class="mobile-menu-links" href="https://postmark.ukrposhta.ua">Маркет</a>
				<a class="mobile-menu-links" href="https://apteka.ukrposhta.ua/">Аптека</a>
				<a class="mobile-menu-links" href="https://track.ukrposhta.ua/tracking_UA.html">Трекінг</a>
				<div class="accordion" id="mobile-header-accordion1">
					<div class="mobile-header-accordion-item">
						<div id="mobile-header-heading1">
							<a class="accordion-headline collapsed" href="javascript:void(0);" role="button" data-toggle="collapse" data-target="#mobile-header-collapse1" aria-expanded="false" aria-controls="mobile-header-collapse1">
								<span class="mobile-menu-links">Послуги</span>
								<i class="fas"></i>
							</a>
						</div>
						<div class="collapse" id="mobile-header-collapse1" aria-labelledby="mobile-header-heading1" data-parent="#mobile-header-accordion1">
							<ul>
								<li class="mobile-menu-sub-title">Поштові послуги</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/ekspres">Доставка за тарифом «Пріоритетний»</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/standart">Доставка за тарифом «Базовий»</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/dokumenty">Укрпошта Документи</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/mizhnarodnyi-poshtovyi-perekaz">Міжнародні поштові перекази</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/dostavka-po-svitu">Доставка по світу</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/dostavka-v-ukrainu">Доставка в Україну</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/vidpravlennia-v">Вантаж</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/lysty-ta-poshtovi-kartky">Листи та листівки</a>
								</li>
								<!-- <li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/banderol">Бандероль</a>
								</li> -->
								<li>
									<a href="http://services.ukrposhta.com/courier" target="_blank">Кур’єрська доставка</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/upakuvannia">Паковання</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/dostavka-z-internet-mahazyniv-ukrposhtoiu">Доставка з інтернет-магазинів</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/sezon-ogorodiv">Доставка товарів для саду</a>
								</li>
							</ul>
							<ul>
								<li class="mobile-menu-sub-title">Сервіси</li>
								<li>
									<a href="https://calc.ukrposhta.ua">Калькулятор</a>
								</li>
								<li>
									<a href="https://ok.ukrposhta.ua/ua">Оформити відправлення</a>
								</li>
								<li>
									<a href="https://index.ukrposhta.ua/find-post-index/">Знайти індекс</a>
								</li>
								<li>
									<a href="https://index.ukrposhta.ua/find-address/">Знайти адресу</a>
								</li>
								<li>
									<a href="https://offices.ukrposhta.ua">Знайти відділення</a>
								</li>
								<li>
									<a href="https://track.ukrposhta.ua/tracking_UA.html">Трекінг</a>
								</li>
                                <li>
                                    <a href="https://{{wwwContent}}ukrposhta.ua/ua/pereadresuvannya-vidpravlennya/">Переадресація відправлення</a>
                                </li>
                                <li>
                                    <a href="https://{{wwwContent}}ukrposhta.ua/ua/rozshuk-vrpv">Компенсація (рекламація)</a>
                                </li>
							</ul>
							<ul>
								<li class="mobile-menu-sub-title">Фінансові послуги</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/perekazy-v-mezhakh-ukrainy">Внутрішні грошові перекази</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/mizhnarodni-platizhni-systemy">Міжнародні платіжні системи (перекази MoneyGram)</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/vnutrishnoderzhavni-platizhni-systemy">Внутрішньодержавні платіжні системи</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/platezhi">Платежі</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/Vydacha-hotivkovykh-hryven-ta-popovnennia-platizhnykh-kartok-cherez-POS-terminaly">Видача готівкових гривень та/або поповнення платіжних карток через POS-термінали</a>
								</li>
                                <li>
                                    <a href="https://{{wwwContent}}ukrposhta.ua/ua/valiutno-obminni-operatsii">Валютно-обмінні операції</a>
                                </li>
							</ul>
							<ul>
								<li class="mobile-menu-sub-title">Інші послуги</li>
                                <li>
                                    <a href="https://{{wwwContent}}ukrposhta.ua/ua/pensii">Пенсії</a>
                                </li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/onlain-servisy">Онлайн-сервіси</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/periodychni-vydannia">Періодичні медіа</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/dlia-vydavtsiv">Для видавців</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/forma-zvorotnoho-zviazku">Зворотний зв’язок за передплатою</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/sekohrama">Секограма</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/vlasna-marka">Продукти «Власної марки»</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/strakhuvannia">Страхові послуги</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/kataloh-ukrposhta-market">Каталог «Укрпошта Маркет»</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="accordion" id="mobile-header-accordion2">
					<div class="mobile-header-accordion-item">
						<div id="mobile-header-heading2">
							<a class="accordion-headline collapsed" href="javascript:void(0);" role="button" data-toggle="collapse" data-target="#mobile-header-collapse2" aria-expanded="false" aria-controls="mobile-header-collapse2">
								<span class="mobile-menu-links">Тарифи</span>
								<i class="fas"></i>
							</a>
						</div>
						<div class="collapse" id="mobile-header-collapse2" aria-labelledby="mobile-header-heading2" data-parent="#mobile-header-accordion2">
							<ul>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-ukrposhta-priorytetnyi">Посилки</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy">Доставка за кордон</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-ukrposhta-dokumenty">Листи та документи</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-platezhi">Фінансові послуги</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-na-pryimannia-ta-dostavku-vydan-za-peredplatoiu">Передплата журналів та газет</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-masovyi-kurierskyi-zabir-abo-dostavka">Кур’єрські послуги</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-vidpravlennia-v">Вантаж</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/taryfy-inshi-posluhy">Інше</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<a class="mobile-menu-links" href="https://offices.ukrposhta.ua">Відділення</a>
				<div class="accordion" id="mobile-header-accordion3">
					<div class="mobile-header-accordion-item">
						<div id="mobile-header-heading3">
							<a class="accordion-headline collapsed" href="javascript:void(0);" role="button" data-toggle="collapse" data-target="#mobile-header-collapse3" aria-expanded="false" aria-controls="mobile-header-collapse3">
								<span class="mobile-menu-links">Філателія</span>
								<i class="fas"></i>
							</a>
						</div>
						<div class="collapse" id="mobile-header-collapse3" aria-labelledby="mobile-header-heading3" data-parent="#mobile-header-accordion3">
							<ul class="sub-menu-list">
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/informatsiia-dlia-pokuptsiv">Інформація для покупців</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/tematychni-plany-vypusku-produktsii">Тематичнi плани випуску продукції</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/filatelistychnyi-abonement">Філателістичний абонемент</a>
								</li>
	                            <li>
	                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/marky-voiennoho-chasu">Поштові марки України воєнного часу</a>
	                            </li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/poriadok-podachi-propozytsii">Порядок подачі пропозицій</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/spetsialni-poshtovi-shtempeli-postiinoi-dii">Спеціальні поштові штемпелі постійної дії</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/zhurnal-filateliia-ukrainy">Журнал «Філателія України»</a>
								</li>
								<li>
									<a href="https://{{wwwContent}}ukrposhta.ua/ua/aleia-poshtovykh-marok">Алея поштових марок</a>
								</li>
	                            <li>
	                                <a href="https://{{wwwContent}}ukrposhta.ua/ua/marky-na-pidtrymku-ukrainy">Марки світу на підтримку України</a>
	                            </li>
							</ul>
						</div>
					</div>
				</div>
				<a class="mobile-menu-links" href="https://{{wwwContent}}ukrposhta.ua/ua/vacancies/">Кар’єра</a>
                <div class="accordion" id="mobile-header-accordion4">
                    <div class="mobile-header-accordion-item">
                        <div id="mobile-header-heading4">
                            <a class="accordion-headline collapsed" href="javascript:void(0);" role="button" data-toggle="collapse" data-target="#mobile-header-collapse4" aria-expanded="false" aria-controls="mobile-header-collapse4">
                                <span class="mobile-menu-links">Для бізнесу</span>
                                <i class="fas"></i>
                            </a>
                        </div>
                        <div class="collapse" id="mobile-header-collapse4" aria-labelledby="mobile-header-heading4" data-parent="#mobile-header-accordion4">
                            <ul class="sub-menu-list">
                                <li>
                                    <a href="https://{{wwwContent}}ukrposhta.ua/ua/ukrposhta-dlia-biznesu">Послуги</a>
                                </li>
                                <li>
                                    <a href="https://{{wwwContent}}ukrposhta.ua/ua/become-a-partner">Партнерські відділення</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
			</div>
			<div class="hide-menu" (click)="hideMobileMenu()">
				<div class="burger-box">
					<div class="burger-inner"></div>
				</div>
			</div>
		</div>
	</div>
</div>
